import { Component, ElementRef, OnDestroy, OnInit, ViewChildren, ViewChild } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FormControl } from "@angular/forms";
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { FuseConfigService } from '../../../../@fuse/services/config/config.service';
import { FuseNavigationService } from "../../../../@fuse/components/navigation/navigation.service";
import { LoginModel, LoginResponseModel, VerifyTwoFactorModel, VerifyCompanyCodeModel } from '../authentication.model';
import { AuthenticationService } from '../authentication.service';
import { AppConfig } from '../../../app.config';
import { Role } from '../../../shared/models/useridentity.model';
import { AppRoute } from '../../../shared/app.routes';
import { NotificationService } from '../../../shared/services/notification.service';
import { ValidationService } from "../../../shared/services/validation.service";
import { GlobalCompanyService } from "../../../shared/component/global-company/global-company.service";
import { CookieService } from 'ngx-cookie-service';
import * as CryptoJS from 'crypto-js';
import { HasPermissionService } from '../../../shared/services/service.index';
import { AcceptTermsAndConditionComponent } from "../accept-terms-and-condition/accept-terms-and-condition.component";
import { trigger, state, style, transition, animate } from '@angular/animations';
import { FuseAlertService } from '@fuse/components/alert';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [
    trigger('animate', [
      state('start', style({
        opacity: 0,
        transform: 'translateY(-20px)'
      })),
      state('end', style({
        opacity: 1,
        transform: 'translateY(0)'
      })),
      transition('start => end', animate('300ms ease-in')),
      transition('end => start', animate('300ms ease-out'))
    ])
  ]
  //animations: fuseAnimations
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm: FormGroup;
  verifyCodeForm: FormGroup;
  autoCompleteCompanyListFormControl: FormControl;
  companyAutocompleteList: any[];
  @ViewChild('loginCompanyAutoComplete', { read: MatAutocompleteTrigger })
  loginCompanytrigger: MatAutocompleteTrigger;

  companyCodeForm: FormGroup;
  loginResponse: LoginResponseModel;

  notificationService: NotificationService;
  isSubmitBtnDisabled: boolean = false;
  isFirstStep: boolean = true;
  iscompanyCodeStep: boolean = false;
  isCompanySecurityCodeAvailable: boolean = false;
  twoFactorModel: VerifyTwoFactorModel;
  companyCodeModel: VerifyCompanyCodeModel;
  apiResponseErrorMessage: string = null;

  isRememberMe: boolean = false;

  /**Dialog Ref variables**/
  confirmDialogRef: MatDialogRef<AcceptTermsAndConditionComponent>;
  dialogRef: any;

  private unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   * @param {FormBuilder} _formBuilder
   */
  private _unsubscribeAll: Subject<any>;
  constructor(
    private router: Router,
    private matDialog: MatDialog,
    private snb: MatSnackBar,
    private fuseConfigService: FuseConfigService,
    private formBuilder: FormBuilder,
    private authenticationservice: AuthenticationService,
    private appConfig: AppConfig,
    private spinner: NgxSpinnerService,
    private location: LocationStrategy,
    private fuseNavigationService: FuseNavigationService,
    private globalCompanyService: GlobalCompanyService,
    private cookieService: CookieService,
    private _hasPermissionService: HasPermissionService,
    private _activatedRoute: ActivatedRoute,
    public fuseAlertService: FuseAlertService,
  ) {
    this.notificationService = new NotificationService(snb);
    this.unsubscribeAll = new Subject();


    // Configure the layout
    this.fuseConfigService.config={
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    }
    this.twoFactorModel = new VerifyTwoFactorModel();
    this.autoCompleteCompanyListFormControl = new FormControl();
    this.companyCodeModel = new VerifyCompanyCodeModel();
    this.loginResponse = new LoginResponseModel();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {

    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, ValidationService.emailValidator]],
      password: ['', Validators.required],
      rememberMe: ['']
    });

    this.verifyCodeForm = this.formBuilder.group({
      code: ['', [Validators.required, ValidationService.noWhiteSpace, ValidationService.onlyNumberValidator]]
    });

    this.companyCodeForm = this.formBuilder.group({
      companyId: [],
      code: ['', [Validators.required, ValidationService.noWhiteSpace, ValidationService.onlyNumberValidator, Validators.pattern("^[0-9]*$"), Validators.maxLength(4)]]
    });

    this.isAlreadyLogin();
    this.getRemeberMe();
  }

  /**
  * On destroy
  */
  ngOnDestroy(): void {
    this.unsubscribeAll.next('');
    this.unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Form events
  // -----------------------------------------------------------------------------------------------------

  /**On click of back to first setp button**/
  backToFirstStep(isLoginThen: boolean = false) {
    this.isFirstStep = true;
    this.iscompanyCodeStep = false;

    if (isLoginThen) {
      this.doLogOut(isLoginThen);
    }
  }

  /**
  * On change remember me
  * @param event
  */
  rememberMe(event) {
    this.isRememberMe = event.checked;
  }

  /**On Submit of login form**/
  login() {
    this.apiResponseErrorMessage = null;
    var loginModel = new LoginModel();
    loginModel.email = this.loginForm.controls.email.value;
    loginModel.password = this.loginForm.controls.password.value;
    loginModel.email = loginModel.email.trim();
    if (this.loginForm.valid) {
      this.isSubmitBtnDisabled = true;
      this.spinner.show();
      this.authenticationservice.adminLogin(loginModel).subscribe(result => {
        this.spinner.hide();
        this.isSubmitBtnDisabled = false;
        if (result.status === 1) { // If Login successfull
          if (this.rememberMe) {
            this.setRememberMe(loginModel);
          }
          this.loginSuccess(result);
        }
        else if (result.status === 2) { // If Requires 2 step verification
          if (this.rememberMe) {
            this.setRememberMe(loginModel);
          }
          this.isSubmitBtnDisabled = false;
          this.isFirstStep = false;
          this.iscompanyCodeStep = false;
          this.twoFactorModel.email = loginModel.email;
        }
        else if (result.status === 3) {
          this.showAcceptTermsAndConditionModal(loginModel.email);
        }
        else if (result.status === 0) {
          this.isSubmitBtnDisabled = false;
          this.apiResponseErrorMessage = result.message;
        }

      });
    };
  }

  /** On submit of verify code form **/
  verifyCode(): void {
    this.apiResponseErrorMessage = null;
    this.twoFactorModel.code = this.verifyCodeForm.controls.code.value;

    if (this.verifyCodeForm.dirty && this.verifyCodeForm.valid) {
      this.spinner.show();
      this.authenticationservice.verifyTwoFactorCode(this.twoFactorModel).subscribe(result => {
        if (result.status === 1) {
          this.verifyCodeForm.controls.code.setValue(null);
          this.spinner.hide();
          this.loginSuccess(result);
          //this.globalCompanyService.expireSubscription = true;
        } else if (result.status === 2) {
          this.showAcceptTermsAndConditionModal(this.twoFactorModel.email);
        }
        else {
          this.spinner.hide();
          this.isSubmitBtnDisabled = false;
          this.apiResponseErrorMessage = result.message;
        }
      });
    };
  }

  /** On submit of verify company Code form **/
  verifyCompanyCode(): void {

    let company = this.autoCompleteCompanyListFormControl.value;
    let companyName = "";
    this.apiResponseErrorMessage = null;
    this.companyCodeModel.userId = this.loginResponse.Response.data.userId;
    //var selectedCompany = this.companyAutocompleteList.filter(x => x.companyName == company.companyName);
    if (company !== null) {
      this.companyCodeModel.companyId = company.companyId;
      companyName = company.companyName;
    }
    let newModel = {
      userId: this.appConfig.getCurrentUserId(),
      companyId: this.companyCodeModel.companyId,
      companyName: companyName,
      isSecurityCodeAvailable: this.isCompanySecurityCodeAvailable,
      isCompanyCodeVerify: false
    };

    if (this.isCompanySecurityCodeAvailable) {
      this.companyCodeModel.code = this.companyCodeForm.controls.code.value;
      if (this.companyCodeForm.dirty && this.companyCodeForm.valid && company != null) {
        this.spinner.show();
        newModel.isCompanyCodeVerify = true;
        this.spinner.hide();
        this.createSeletctedCompanyCookie(newModel, true);
        this.loginExceed(this.loginResponse.Response);
        // this.globalCompanyService.verifyCompanyCode(this.companyCodeModel).subscribe(result => {
        //   if (result.status === 1) {
        //     newModel.isCompanyCodeVerify = true;
        //     this.spinner.hide();
        //     this.createSeletctedCompanyCookie(newModel, true);
        //     this.loginExceed(this.loginResponse.Response);
        //   }
        //   else {
        //     this.spinner.hide();
        //     this.isSubmitBtnDisabled = false;
        //     this.apiResponseErrorMessage = result.message;
        //     this.createSeletctedCompanyCookie(newModel);
        //   }
        // });
      };
    } else {
      if (this.autoCompleteCompanyListFormControl.value != null) {
        this.companyCodeModel.code = "0";
        if (!this.companyCodeModel.companyId)
          this.companyCodeModel.companyId = 0;
        this.spinner.show();
        this.createSeletctedCompanyCookie(newModel, true);
        this.spinner.hide();
        this.loginExceed(this.loginResponse.Response);
        // this.globalCompanyService.verifyCompanyCode(this.companyCodeModel).subscribe(result => {
        //   if (result.status === 1) {
        //     this.createSeletctedCompanyCookie(newModel, true);
        //     this.spinner.hide();
        //     this.loginExceed(this.loginResponse.Response);
        //   }
        //   else {
        //     this.createSeletctedCompanyCookie(newModel);
        //     this.spinner.hide();
        //     this.apiResponseErrorMessage = result.message;
        //   }
        // });
      }
    }

  }

  createSeletctedCompanyCookie(model, isCompanyCodeVerify: boolean = false) {
    model.isCompanyCodeVerify = isCompanyCodeVerify;
    var todayDate = new Date();
    todayDate.setDate(todayDate.getDate() + 365);
    this.cookieService.delete('RiskSelectedCompany', "/");
    this.cookieService.set('RiskSelectedCompany', JSON.stringify(model), todayDate, "/");
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**Get rememebered email and password from cookie**/
  getRemeberMe() {
    var cookieValue = this.cookieService.get('_rememberMe');
    if (cookieValue !== null && cookieValue !== undefined && cookieValue !== "")
      var rememberMeModel = JSON.parse(cookieValue);
    if (rememberMeModel !== undefined && rememberMeModel !== null) {
      if (rememberMeModel.token !== null && rememberMeModel.token !== undefined && rememberMeModel.email !== null && rememberMeModel.email !== undefined) {
        var token = CryptoJS.AES.decrypt(rememberMeModel.token, rememberMeModel.email).toString(CryptoJS.enc.Utf8);
        this.loginForm.controls.email.setValue(rememberMeModel.email);
        this.loginForm.controls.password.setValue(token);
      }
    }
  }

  /**Check if user is already login redirect to dashboard**/
  isAlreadyLogin() {
    if (!this.appConfig.isAuthenticated()) return;
    var user = this.appConfig.getCurrentUser();
    if (user !== null) {
      this.loginResponse.Response = {
        status: 1,
        data: user
      };
      this.authenticationservice.verifyToken().subscribe(res => {
        if (res.status === 1) {
          //this.fuseAlertService.show(res.message, res.status);
          //this.router.navigateByUrl(AppRoute.dashboard);
          if (user.isCompanyMoreThenOne) {
            /*Get User Company List*/
            this.getUserCompanyList(this.loginResponse.Response.data.userId);
          } else {
            this.router.navigateByUrl(AppRoute.dashboard);
          }
        } else {
          this.appConfig.removeCurrentUser();
        }
      });
    }
  }

  loginSuccess(result) {
    this.isFirstStep = true;
    this.appConfig.setCurrentUser(result.data);
    this.loginResponse.Response = result;
    /*Check Assigned Company More Then One */
    if (result.data.isCompanyMoreThenOne) {
      /*Get User Company List*/
      this.getUserCompanyList(this.loginResponse.Response.data.userId);
    } else {
      this.iscompanyCodeStep = false;
      this.loginExceed(result);
    }
  }

  getUserCompanyList(userId: string) {
    this.globalCompanyService.setAssignedCompanyByLoginUserList(userId);
    /* Check User is SystemPowerAdmin or SystemAdmin*/
    if (this.loginResponse.Response.data.isSpaOrSa) {
      /*Check Security Code Enabled*/
      if (this.loginResponse.Response.data.isSecurityCodeEnabled) {
        this.globalCompanyService.assignedCompany.subscribe(res => {
          if (res !== 0 && res.length > 0) {
            /*Set User Company List To Auto Complete*/
            this.companyAutocompleteList = res.map(o => {
              return {
                companyId: o.companyId,
                companyName: o.companyName,
                isFavourite: o.isFavourite,
                isSecurityCodeAvailable: o.isSecurityCodeAvailable
              };
            });

            this.companyCodeProcess(this.loginResponse.Response);
          }
        });
      } else {
        this.iscompanyCodeStep = false;
        this.loginExceed(this.loginResponse.Response);
      }
    } else {
      this.globalCompanyService.assignedCompany.subscribe(res => {
        if (res !== 0 && res.length > 0) {
          /*Set User Company List To Auto Complete*/
          this.companyAutocompleteList = res.map(o => {
            return {
              companyId: o.companyId,
              companyName: o.companyName,
              isFavourite: o.isFavourite,
              isSecurityCodeAvailable: o.isSecurityCodeAvailable
            };
          });

          this.companyCodeProcess(this.loginResponse.Response);
        }
      });
    }

  }

  companyCodeProcess(result) {
    /*Check Previous Selected Company*/
    if (this.cookieService.check("RiskSelectedCompany")) {
      let riskSelectedCompany = JSON.parse(this.cookieService.get("RiskSelectedCompany"));

      this.loginResponse.SelectedCompany = riskSelectedCompany;

      if (riskSelectedCompany != null || riskSelectedCompany != undefined) {
        if (riskSelectedCompany.userId == result.data.userId) {
          this.autoCompleteCompanyListFormControl.setValue(riskSelectedCompany.companyName);
          this.isCompanySecurityCodeAvailable = riskSelectedCompany.isSecurityCodeAvailable;
          this.isFirstStep = true;
          this.iscompanyCodeStep = true;
          ///* Company Security Code Available */
          //if (this.isCompanySecurityCodeAvailable) {
          //  this.iscompanyCodeStep = true;
          //} else {
          //  this.loginExceed(this.loginResponse.Response);
          //}
        }
      } else {
        if (this.companyAutocompleteList.length !== 0) {
          this.autoCompleteCompanyListFormControl.setValue(this.companyAutocompleteList[0].companyName);
          this.isCompanySecurityCodeAvailable = this.companyAutocompleteList[0].isSecurityCodeAvailable;
        } else {
          this.isCompanySecurityCodeAvailable = true;
        }
        this.isFirstStep = true;
        this.iscompanyCodeStep = true;
        ///* Company Security Code Available */
        //if (this.isCompanySecurityCodeAvailable) {
        //  this.iscompanyCodeStep = true;
        //} else {
        //  this.loginExceed(this.loginResponse.Response);
        //}
      }
    } else {
      if (this.companyAutocompleteList.length !== 0) {
        let firstCompanyFromList = this.companyAutocompleteList[0];
        //let newModel = {
        //  userId: this.loginResponse.Response.userId,
        //  companyId: firstCompanyFromList.companyId,
        //  companyName: firstCompanyFromList.companyName,
        //  isSecurityCodeAvailable: firstCompanyFromList.isSecurityCodeAvailable
        //};
        this.autoCompleteCompanyListFormControl.setValue(firstCompanyFromList.companyName);
        this.isCompanySecurityCodeAvailable = firstCompanyFromList.isSecurityCodeAvailable;

      } else {
        this.isCompanySecurityCodeAvailable = true;
      }
      this.isFirstStep = true;
      this.iscompanyCodeStep = true;
      ///* Company Security Code Available */
      //if (this.isCompanySecurityCodeAvailable) {
      //  this.iscompanyCodeStep = true;
      //} else {
      //  this.loginExceed(this.loginResponse.Response);
      //}
    }
  }

  loginExceed(result) {
    this.globalCompanyService.expireSubscription = true;
    this._hasPermissionService.getUserPermission().subscribe(res => {
      if (res.status === 1) {
        this._hasPermissionService.isApiCallCompleted = true;
        this._hasPermissionService.setCurrUserPermissions(res.data);
        //this.fuseAlertService.show(res.message, res.status);
        if (result.data.roleId === Role.ClientUser) {
          if (this._hasPermissionService.hasPermission("policyselection", "list"))
            this.router.navigate([AppRoute.policySelectionRoute]);
          else if (this._hasPermissionService.hasPermission("assessmentdashboard", "list"))
            this.router.navigate([AppRoute.dashboard]);
          else 
            this.router.navigate([AppRoute.assessmentListRoute]);
        }
        else if (result.data.roleId === Role.SystemPowerAdmin || result.data.roleId === Role.SystemAdmin || result.data.roleId === Role.ClientAdmin) {
          //this.router.navigate([AppRoute.policySelectionRoute]);
          const redirectURL =
                    this._activatedRoute.snapshot.queryParamMap.get(
                        'redirectURL'
                    ) || '/signed-in-redirect';
        }
        else {
          if (this._hasPermissionService.hasPermission("policyselection", "list"))
            this.router.navigate([AppRoute.policySelectionRoute]);
          else
            this.router.navigate([AppRoute.dashboard]);
        }
      }
    });
    this.globalCompanyService.setAssignedCompanyList();
  }

  /**
   * * On chnage Company Auto Complete 
   * @param event
   */
  onChangeCompany(event) {
    if (event.source.selected) {
      this.globalCompanyService.globalParentAssessment = 0;
      this.globalCompanyService.globalCompany = event.source.value.companyId;


      let newModel = {
        userId: this.loginResponse.Response.data.userId,
        companyId: event.source.value.companyId,
        companyName: event.source.value.companyName,
        isSecurityCodeAvailable: event.source.value.isSecurityCodeAvailable,
        isCompanyCodeVerify: false
      };

      this.autoCompleteCompanyListFormControl.setValue(newModel.companyName);
      this.isCompanySecurityCodeAvailable = newModel.isSecurityCodeAvailable;

      var todayDate = new Date();
      todayDate.setDate(todayDate.getDate() + 365);
      this.cookieService.delete('RiskSelectedCompany', "/");
      this.cookieService.set('RiskSelectedCompany', JSON.stringify(newModel), todayDate, "/");
    }

  }

  /**Auto complete filter on change**/
  onInputChanged(searchStr: string): void {
    this.companyAutocompleteList = [];

    this.companyAutocompleteList = this.globalCompanyService.assignedCompany.filter(option =>
      option.companyName.toLowerCase().includes(searchStr.toLowerCase())).map(o => {
        return {
          companyId: o.companyId,
          companyName: o.companyName,
          isFavourite: o.isFavourite,
          isSecurityCodeAvailable: o.isSecurityCodeAvailable
        };
      });

  }

  /**
   * *Set Remember me in Cookies
   * @param model
   */
  setRememberMe(model) {
    var token = CryptoJS.AES.encrypt(model.password, model.email).toString();;
    var rememberMe = {
      email: model.email,
      token: token
    }

    var todayDate = new Date();
    todayDate.setDate(todayDate.getMonth() + 12);

    this.cookieService.delete('_rememberMe', "/");
    this.cookieService.set('_rememberMe', JSON.stringify(rememberMe), todayDate, "/");
  }

  showAcceptTermsAndConditionModal(email) {
    this.dialogRef = this.matDialog.open(AcceptTermsAndConditionComponent, {
      width: '450px',
      panelClass: "terms-condition-box"
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
        }
        const actionType: string = response[0];
        switch (actionType) {
          case 'submit':
            const isAccepted: string = response[1];
            if (isAccepted) {
              this.acceptTermsAndCondition(email);
            } else {
              this.fuseAlertService.show("Terms and condition not accepted", 2);
            }
            break;
          default:
            this.fuseAlertService.show("Terms and condition not accepted", 2);
            break;
        }
      });
  }

  acceptTermsAndCondition(email) {
    this.authenticationservice.acceptTermsAndCondition(email).subscribe(res => {
      if (res.status === 1) {
        //this.fuseAlertService.show(res.message, res.status);
        this.loginSuccess(res);
      } else {
        this.apiResponseErrorMessage = res.message;
      }
    });
  }

  doLogOut(isRedirectToLink: boolean = false) {
    this.authenticationservice.logout().subscribe(res => {
      this.appConfig.removeCurrentUser();
      if (res.status === 1) {
        if (isRedirectToLink == false) {
          this.globalCompanyService.setAssignedCompanyList();
          this.globalCompanyService.expireSubscription = false;
          //this.fuseAlertService.show(res.message, res.status);
          window.location.href = "https://bizzsecure.com";
          //this.router.navigate([AppRoute.loginAdmin]);
        }
      }
    });

  }

}
